// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grapes-doc-editor[data-v-0b98bf1d] {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.grapes-doc-editor__canvas[data-v-0b98bf1d] {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
